import React, { useState, useEffect } from 'react';
import { Button, Card, Radio, Flex } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

import EntityBlock from './EntityBlock';

const ConditionSwitcher = ({ value, onChange }) => {
  const [twoCondition, setTwoCondition] = useState(value?.type === 'and' || value?.type === 'or');

  return twoCondition ? (
    <Card size='small' title="Operator Block" hoverable>
      <TwoConditionBlock
        value={value}
        onChange={onChange}
        setTwoCondition={setTwoCondition}
      />
    </Card>
  ) : (
    <Card size='small' title='Entity Block' hoverable>
      <EntityBlock value={value} onChange={onChange} />
      <Button
        icon={<PlusOutlined />}
        type="dashed"
        onClick={() => {
          onChange({ type: 'and', statement: [value, {}] });
          setTwoCondition(true);
        }}
        block
        style={{ marginTop: 24 }}
      >
        Add Condition
      </Button>
    </Card>
  );
};

const TwoConditionBlock = ({ value, onChange, setTwoCondition }) => {
  const [operator, setOperator] = useState(value?.type || 'and');
  const [statement, setStatement] = useState(value?.statement || [{}, {}]);

  useEffect(() => {
    const newValue = { type: operator, statement };
    
    if (JSON.stringify(value) !== JSON.stringify(newValue)) {
      onChange(newValue);
    }
  }, [operator, statement, value, onChange]);

  const updateStatement = (index, newValue) => {
    const updatedStatement = [...statement];
    updatedStatement[index] = newValue;
    setStatement(updatedStatement);
  };

  return (
    <Flex vertical gap={8} style={{ width: '100%' }}>
      <ConditionSwitcher
        value={statement[0]}
        onChange={(val) => updateStatement(0, val)}
      />
      <Radio.Group
        options={[{ value: 'and', label: 'AND' }, { value: 'or', label: 'OR' }]}
        onChange={(e) => setOperator(e.target.value)}
        value={operator}
        style={{ alignSelf: 'center', marginTop: 4, marginBottom: 4 }}
      />
      <ConditionSwitcher
        value={statement[1]}
        onChange={(val) => updateStatement(1, val)}
      />
      <Button
        type="dashed"
        icon={<DeleteOutlined />}
        block
        onClick={() => {
          setTwoCondition(false);
          onChange(statement[0]);
        }}
        style={{ marginTop: 16 }}
      >
        Remove Condition
      </Button>
    </Flex>
  );
};

export default ConditionSwitcher;
